export const getExpenseDetails = (payload, showUpdate) => ({
  type: 'GET_SINGLE_TRANSACTION',
  showShimmer: true,
  payload,
  showUpdate,
});
export const setExpenseDetails = (data, showUpdate) => ({
  type: 'SET_EXPENSE_DETAILS',
  data,
  showUpdate,
});
export const getBillAttachment = payload => ({
  type: 'BILL_ATTACHMENT',
  loader: true,
  payload,
});
export const setBillAttachment = data => ({
  type: 'SET_BILL_ATTACHMENT',
  data,
});
export const updateBillAndDescripion = (fileData, commentData) => ({
  type: 'BILL_COMMENT_UPDATE',
  loader: true,
  fileData,
  commentData,
});
export const setBillAndDescripion = data => ({
  type: 'SET_BILL_DESCRIPTION',
  data,
});
export const updateDescripion = payload => ({
  type: 'UPDATE_DESCRIPTION',
  loader: true,
  payload,
});

export const getBillAttachmentDelete = payload => ({
  type: 'BILL_ATTACHMENT_DELETE',
  loader: true,
  payload,
});
export const setBillAttachmentDelete = data => ({
  type: 'SET_BILL_ATTACHMENT_DELETE',
  data,
});
export const updateDisputeInTxn = (payloadDispute, callBack) => ({
  type: 'DISPUTE_WITHDRAW',
  payloadDispute,
  callBack,
});
export const showSnackbar = data => ({
  type: 'SHOW_SNACK_BAR',
  data,
});
